"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountPictogram = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var Pictogram_1 = require("../Pictogram");
var AccountPictogram = function (props) {
    var alt = props.alt, productCode = props.productCode, productSubCode = props.productSubCode;
    var product;
    var pictogramName;
    if (props.productSubCode) {
        product = "" + productCode + productSubCode;
        if (honeycomb_1.ProductCodes.ProductPictogramLookup[product]) {
            pictogramName = honeycomb_1.ProductCodes.ProductPictogramLookup[product];
        }
        else {
            pictogramName = honeycomb_1.ProductCodes.ProductPictogramLookup[productCode];
            /* tslint:disable no-console */
            console.warn("product subcode:" + props.productSubCode + " could not be found");
            /* tslint:enable no-console */
        }
    }
    else {
        product = productCode;
        pictogramName = honeycomb_1.ProductCodes.ProductPictogramLookup[product];
    }
    if (pictogramName) {
        return (React.createElement(Pictogram_1.Pictogram, { name: pictogramName, alt: alt }));
    }
    return (React.createElement("div", null,
        "product: ",
        productCode,
        " could not be found"));
};
exports.AccountPictogram = AccountPictogram;
/* tslint:disable:no-string-literal */
exports.AccountPictogram['propTypes'] = {
    productCode: PropTypes.string,
};
/* tslint:enable:no-string-literal */
